import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideModuleInfo } from '@mp/shared/util';
import { ADDRESS_EDIT_TAB_PLUGIN } from '@mpomd/shared/util';

import { createAddressEditTabPlugin } from '../plugins';

const moduleName = 'ClinicSupplierAddressCodes';

export function provideClinicSupplierAddressCodesFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Lieferanten Adresscodes',
    }),
    makeEnvironmentProviders([
      { provide: ADDRESS_EDIT_TAB_PLUGIN, multi: true, useFactory: createAddressEditTabPlugin },
    ]),
  ];
}
